import type React from 'react';

import { Handle, Position } from '@xyflow/react';
import { useTranslate } from 'react-admin';

import NodeBody from './NodeBody';

import type { NodeBodyProps } from './NodeBody';
import type { SortableInput } from '../dataProvider/types';

interface NodeBodyWithDefaultConnectionProps extends NodeBodyProps {
  defaultConnection?: SortableInput;
}

const NodeBodyWithDefaultConnection = ({
  defaultConnection = {
    id: 'default_connection-source',
    value: 'callflows.components.sortableInstructionsList.defaultConnection',
  },
  handles = [],
  backgroundColor = undefined,
  children = null,
  ...props
}: NodeBodyWithDefaultConnectionProps): React.ReactElement => {
  const translate = useTranslate();
  const translatedDefaultConnection: SortableInput = {
    ...defaultConnection,
    value: translate(defaultConnection.value),
  };
  if ((handles !== undefined && handles.length > 0) || children !== null) {
    return (
      <NodeBody handles={[translatedDefaultConnection, ...handles]} backgroundColor={backgroundColor} {...props}>
        {children}
      </NodeBody>
    );
  }
  return <Handle type='source' position={Position.Right} id={defaultConnection.id} />;
};

export default NodeBodyWithDefaultConnection;
